import { render, staticRenderFns } from "./MaveDevices.vue?vue&type=template&id=c2b644c4&scoped=true"
import script from "./MaveDevices.vue?vue&type=script&lang=js"
export * from "./MaveDevices.vue?vue&type=script&lang=js"
import style0 from "./MaveDevices.vue?vue&type=style&index=0&id=c2b644c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b644c4",
  null
  
)

export default component.exports